import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { shouldForwardProp } from "../common/Common.style";

type StyleBoxProps = {
  isChatLoading?: boolean;
};

export const ChatListContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    shouldForwardProp<StyleBoxProps>(["isChatLoading"], prop),
})<StyleBoxProps>(({ isChatLoading }) => ({
  overflow: "auto",
  display: "block",
  maxHeight: `calc(100% - ${isChatLoading ? "180px" : "106px"})`,
  position: "relative",
}));

export const ChatListItemTitle = styled(Typography)`
  text-transform: capitalize;
  width: 200px;
`;

export const ChatListItemBody = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 9rem;
`;

export const ChatListItemTimestamp = styled(Typography)`
  margin-bottom: 3px;
  font-size: 12px;
`;

export const ListItemWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

export const ChatListItemWrapper = styled(Box)`
  flex-direction: column;
`;
